enum PCRChannels {
  Summary = 'summary',
  TikTok = 'tiktok',
  IGPosts = 'instagramPosts',
  Reel = 'reel',
  IGStories = 'instagramStories',
  X = 'x',
  Snap = 'snap',
  YouTubeShorts = 'youtubeShorts',
  YouTubeVideos = 'youtubeVideos',
  Facebook = 'facebook',
}

export { PCRChannels }
